// ** Dropdowns Imports
import UserDropdown from './UserDropdown';

// ** Third Party Components
import { Button } from 'reactstrap';
import userState from '../../../../recoil/atoms/auth/user';
import { useRecoilState } from 'recoil';
import useJwt from '@src/@core/auth/jwt/useJwt';

const NavbarUser = props => {
  const [user] = useRecoilState(userState);
  const { jwt } = useJwt();

  const getSource = () => {
    const source = new URLSearchParams(location.search).get("utm_source");
    if (source) return source;
    return null;
  };

  const beginLogin = () => {
    const clientId = jwt.getClientId();
    let path = `/${clientId}?redirect=pets`;
    if (getSource()) {
      path += `&utm_source=${getSource()}`
    }
    window.location.href = path
  };

  return (
    <ul className="nav navbar-nav align-items-center">
      <div className="user-nav">
        {!user && (
          <Button color="link" style={{ marginRight: '-14px' }} onClick={beginLogin}>
            Login
          </Button>
        )}
      </div>
      <UserDropdown />
    </ul>
  );
};
export default NavbarUser;
